import React from 'react';
import { Container, Title, Text, Button, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const goHome = () => navigate('/'); // Redirige vers la page d'accueil

  return (
    <Container style={{ textAlign: 'center', paddingTop: '100px' }}>
      <Title order={1} color="primary" style={{ fontSize: '120px', fontWeight: 900 }}>
        404
      </Title>
      <Title order={2} color="primary" style={{ fontSize: '36px', fontWeight: 700 }} mt="md">
        Page not found
      </Title>
      <Text color="dimmed" size="lg" mt="sm">
        Sorry, the page you are looking for does not exist or has been moved.
      </Text>
      <Group position="center" mt="xl">
        <Button variant="filled" color="primary" leftIcon={<IconArrowLeft />} onClick={goHome}>
          Go back to Home
        </Button>
      </Group>
    </Container>
  );
};

export default NotFoundPage;